export default __webpack_public_path__ + "static/honda_green-b55d7eb7f3ecfbb22dafa86e42b8af6a.jpg";